import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

import { PrivateRoute } from './PrivateRoute';
import { TopPage } from '../Pages/TopPage';
import { PolicyPage } from '../Pages/PolicyPage';
import { SchedulePage } from '../Pages/SchedulePage';
import { MemoryPage } from '../Pages/MemoryPage';
import { ContactPage } from '../Pages/ContactPage';

import { SignInPage } from '../Pages/SignInPage';
import { AdministratorManagementPage } from '../Pages/MemberOnlyPage/AdministratorManagementPage';
import { SharedVideosPage } from '../Pages/MemberOnlyPage/SharedVideosPage';

// import { RecruitmentPage } from '../Pages/RecruitmentPage';
// import { StaffPage } from '../Pages/StaffPage';
// import { GamesPage } from '../Pages/GamesPage';
// import { GamesStandingPage } from '../Pages/GamesPage/GamesStandingPage';
// import { GamesScoreboardPage } from '../Pages/GamesPage/GamesScorePage';
// import { GraduationPlayersPage } from '../Pages/GraduationPlayersPage';

export const AppRoutes = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<TopPage />} />
                <Route path="/policy" element={<PolicyPage />} />
                <Route path="/schedule" element={<SchedulePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/memory" element={<MemoryPage />} />

                <Route path="/member-only" element={<PrivateRoute />}>
                    <Route path="admin-management" element={<AdministratorManagementPage />} />
                    <Route path="shared-videos" element={<SharedVideosPage />} />
                    <Route path="" element={<Navigate to="shared-videos" />} />
                </Route>

                {/* <Route path="/staff" element={<StaffPage />} />
                <Route path="/graduation-players" element={<GraduationPlayersPage />} />
                <Route path="/recruitment" element={<RecruitmentPage />} />
                <Route path="/games" element={<GamesPage />}>
                    <Route path="standing" element={<GamesStandingPage />} />
                    <Route path="scoreboard" element={<GamesScoreboardPage />} />
                </Route> */}

                <Route path="/sign-in" element={<SignInPage />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
            <Outlet />
        </>
    )
}
